// extracted by mini-css-extract-plugin
export default {"f":"fca6ae29f6","main":"_0e45b2985e","btn":"_8e0fa48568","w":"c5f1b6656f","h":"_9e196ee9ad","lh25":"e0f84dbd42","wb":"c670f98960","b":"_45f29d20f8","bx":"acef7a598e"};